"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTokenFromTokensList = exports.useWizardStore = exports.WizardActionStatus = exports.WizardAction = exports.useOrdersStore = exports.handleFillDelayText = exports.fillDelayText = exports.amountUi = exports.amountBN = exports.parseOrderUi = exports.useTwapStore = exports.TimeResolution = void 0;
var bignumber_js_1 = __importDefault(require("bignumber.js"));
var twap_1 = require("@orbs-network/twap");
var moment_1 = __importDefault(require("moment"));
var zustand_1 = require("zustand");
var middleware_1 = require("zustand/middleware");
var lodash_1 = __importDefault(require("lodash"));
var web3_candies_1 = require("@defi.org/web3-candies");
var consts_1 = require("./consts");
var TimeResolution;
(function (TimeResolution) {
    TimeResolution[TimeResolution["Minutes"] = 60000] = "Minutes";
    TimeResolution[TimeResolution["Hours"] = 3600000] = "Hours";
    TimeResolution[TimeResolution["Days"] = 86400000] = "Days";
})(TimeResolution = exports.TimeResolution || (exports.TimeResolution = {}));
var SUGGEST_CHUNK_VALUE = 100;
/**
 * TWAP Store
 */
var initialState = {
    showSuccessModal: true,
    showLoadingModal: false,
    lib: undefined,
    srcToken: undefined,
    dstToken: undefined,
    wrongNetwork: undefined,
    srcAmountUi: "",
    limitPriceUi: { priceUi: "", inverted: false, custom: false },
    srcUsd: (0, bignumber_js_1.default)(0),
    dstUsd: (0, bignumber_js_1.default)(0),
    srcBalance: (0, bignumber_js_1.default)(0),
    dstBalance: (0, bignumber_js_1.default)(0),
    loading: false,
    isLimitOrder: false,
    confirmationClickTimestamp: (0, moment_1.default)(),
    showConfirmation: false,
    disclaimerAccepted: true,
    chunks: 0,
    customDuration: { resolution: TimeResolution.Minutes, amount: undefined },
    customFillDelay: { resolution: TimeResolution.Minutes, amount: 2 },
    orderCreatedTimestamp: undefined,
};
exports.useTwapStore = (0, zustand_1.create)((0, middleware_1.combine)(initialState, function (set, get) { return ({
    setShowSuccessModal: function (showSuccessModal) { return set({ showSuccessModal: showSuccessModal }); },
    setShowLodingModal: function (showLoadingModal) { return set({ showLoadingModal: showLoadingModal }); },
    setLimitOrderPriceUi: function () {
        set({ limitPriceUi: { priceUi: get().getMarketPrice(false).marketPriceUi, inverted: false, custom: false } });
    },
    setLimitOrder: function (isLimitOrder) {
        set({ isLimitOrder: isLimitOrder });
        if (!isLimitOrder) {
            set({ limitPriceUi: initialState.limitPriceUi });
        }
    },
    setStoreOverrideValues: function (storeOverride) {
        set(__assign(__assign(__assign({}, initialState), storeOverride), { lib: get().lib, srcToken: get().srcToken, dstToken: get().dstToken, srcUsd: get().srcUsd, dstUsd: get().dstUsd, srcBalance: get().srcBalance, dstBalance: get().dstBalance }));
    },
    setOrderCreatedTimestamp: function (orderCreatedTimestamp) { return set({ orderCreatedTimestamp: orderCreatedTimestamp }); },
    reset: function (storeOverride) { return set(__assign(__assign(__assign({}, initialState), { lib: get().lib }), storeOverride)); },
    setLib: function (lib) { return set({ lib: lib }); },
    setLoading: function (loading) { return set({ loading: loading }); },
    setSrcToken: function (srcToken) {
        set({ srcToken: srcToken });
    },
    setDstToken: function (dstToken) {
        set({ dstToken: dstToken, limitPriceUi: __assign(__assign({}, get().limitPriceUi), { custom: false }) });
    },
    setSrcAmountUi: function (srcAmountUi) {
        set({ srcAmountUi: srcAmountUi });
        get().setChunks(get().chunks);
    },
    setSrcBalance: function (srcBalance) { return set({ srcBalance: srcBalance }); },
    setDstBalance: function (dstBalance) { return set({ dstBalance: dstBalance }); },
    setSrcUsd: function (srcUsd) { return set({ srcUsd: srcUsd }); },
    setDstUsd: function (dstUsd) { return set({ dstUsd: dstUsd }); },
    getMaxSrcInputAmount: function () {
        var srcToken = get().srcToken;
        if ((0, web3_candies_1.isNativeAddress)((srcToken === null || srcToken === void 0 ? void 0 : srcToken.address) || "")) {
            var balance = get().srcBalance;
            var srcTokenMinimum = (0, exports.amountBN)(srcToken, consts_1.MIN_NATIVE_BALANCE.toString());
            return bignumber_js_1.default.max(0, bignumber_js_1.default.min(balance.minus(srcTokenMinimum)));
        }
    },
    getSrcAmount: function () { return (0, exports.amountBN)(get().srcToken, get().srcAmountUi); },
    getDstAmount: function () {
        if (!get().lib || !get().srcToken || !get().dstToken || get().srcUsd.isZero() || get().dstUsd.isZero())
            return (0, bignumber_js_1.default)(0);
        return get().lib.dstAmount(get().srcToken, get().dstToken, get().getSrcAmount(), get().srcUsd, get().dstUsd, get().getLimitPrice(false).limitPrice, !get().isLimitOrder);
    },
    getFillWarning: function (translation) {
        if (!translation)
            return;
        var chunkSize = get().getSrcChunkAmount();
        var srcToken = get().srcToken;
        var dstToken = get().dstToken;
        var srcBalance = get().srcBalance;
        var srcAmount = get().getSrcAmount();
        var lib = get().lib;
        var deadline = get().getDeadline();
        var isLimitOrder = get().isLimitOrder;
        var limitPrice = get().getLimitPrice(false);
        var maxSrcInputAmount = get().getMaxSrcInputAmount();
        var isNativeTokenAndValueBiggerThanMax = maxSrcInputAmount && (srcAmount === null || srcAmount === void 0 ? void 0 : srcAmount.gt(maxSrcInputAmount));
        if (!srcToken || !dstToken || (lib === null || lib === void 0 ? void 0 : lib.validateTokens(srcToken, dstToken)) === twap_1.TokensValidation.invalid)
            return translation.selectTokens;
        if (srcAmount.isZero())
            return translation.enterAmount;
        if ((srcBalance && srcAmount.gt(srcBalance)) || isNativeTokenAndValueBiggerThanMax)
            return translation.insufficientFunds;
        if (chunkSize.isZero())
            return translation.enterTradeSize;
        if (get().getDurationUi().amount === 0)
            return translation.enterMaxDuration;
        if (isLimitOrder && limitPrice.limitPrice.isZero())
            return translation.insertLimitPriceWarning;
        var valuesValidation = lib === null || lib === void 0 ? void 0 : lib.validateOrderInputs(srcToken, dstToken, srcAmount, chunkSize, get().getDstMinAmountOut(), deadline, get().getFillDelayUiMillis() / 1000, get().srcUsd);
        if (valuesValidation === twap_1.OrderInputValidation.invalidTokens) {
            return translation.selectTokens;
        }
        if (valuesValidation === twap_1.OrderInputValidation.invalidSmallestSrcChunkUsd) {
            return translation.tradeSizeMustBeEqual;
        }
        if (get().getFillDelayWarning()) {
            return translation.fillDelayWarning;
        }
    },
    getIsPartialFillWarning: function () { return get().getChunks() * get().getFillDelayUiMillis() > get().getDurationMillis(); },
    setDisclaimerAccepted: function (disclaimerAccepted) { return set({ disclaimerAccepted: disclaimerAccepted }); },
    setWrongNetwork: function (wrongNetwork) { return set({ wrongNetwork: wrongNetwork }); },
    setLimitPriceUi: function (limitPriceUi) { return set({ limitPriceUi: __assign(__assign({}, limitPriceUi), { custom: true }) }); },
    setChunks: function (chunks) { return set({ chunks: Math.min(chunks, get().getMaxPossibleChunks()) }); },
    setDuration: function (customDuration) { return set({ customDuration: customDuration }); },
    isSameNativeBasedToken: function () {
        return !!get().lib &&
            !!get().srcToken &&
            !!get().dstToken &&
            (get().lib.isNativeToken(get().srcToken) || get().lib.isNativeToken(get().dstToken)) &&
            (get().lib.isWrappedToken(get().srcToken) || get().lib.isWrappedToken(get().dstToken));
    },
    getMaxPossibleChunks: function () { return (get().lib && get().srcToken ? get().lib.maxPossibleChunks(get().srcToken, (0, exports.amountBN)(get().srcToken, get().srcAmountUi), get().srcUsd) : 1); },
    getChunks: function () {
        var srcUsd = get().srcUsd;
        var srcToken = get().srcToken;
        var chunks = get().chunks;
        if (!srcUsd || !srcToken)
            return 1;
        if (chunks >= 1)
            return chunks;
        var maxPossibleChunks = get().getMaxPossibleChunks();
        var srcAmountUsd = get().getSrcAmount().times(get().srcUsd);
        return Math.min(maxPossibleChunks, srcAmountUsd.div((0, bignumber_js_1.default)(10).pow(srcToken.decimals)).idiv(SUGGEST_CHUNK_VALUE).toNumber() || 1);
    },
    getMarketPrice: function (inverted) {
        var leftToken = inverted ? get().dstToken : get().srcToken;
        var rightToken = !inverted ? get().dstToken : get().srcToken;
        var leftUsd = inverted ? get().dstUsd : get().srcUsd;
        var rightUsd = !inverted ? get().dstUsd : get().srcUsd;
        var marketPrice = !leftUsd.isZero() && !rightUsd.isZero() ? leftUsd.div(rightUsd) : (0, bignumber_js_1.default)(0);
        return {
            leftToken: leftToken,
            rightToken: rightToken,
            marketPrice: marketPrice,
            marketPriceUi: marketPrice.toFormat(),
            loading: !leftToken || !rightToken ? false : leftUsd.isZero() || rightUsd.isZero(),
        };
    },
    getLimitPrice: function (showingInverted) {
        var leftToken = showingInverted ? get().dstToken : get().srcToken;
        var rightToken = !showingInverted ? get().dstToken : get().srcToken;
        var invertedUi = (0, web3_candies_1.parsebn)(get().limitPriceUi.priceUi).isZero() ? "" : (0, bignumber_js_1.default)(1).div((0, web3_candies_1.parsebn)(get().limitPriceUi.priceUi)).toFormat();
        var limitPriceUi = showingInverted === get().limitPriceUi.inverted ? get().limitPriceUi.priceUi : invertedUi;
        var limitPrice = (0, web3_candies_1.parsebn)(limitPriceUi);
        return {
            leftToken: leftToken,
            rightToken: rightToken,
            limitPriceUi: limitPriceUi,
            limitPrice: limitPrice,
        };
    },
    setTokens: function (srcToken, dstToken) {
        get().setSrcToken(srcToken);
        get().setDstToken(dstToken);
    },
    setFillDelay: function (fillDelay) {
        set({ customFillDelay: fillDelay });
    },
    getDurationUi: function () {
        if (!get().lib)
            return { resolution: TimeResolution.Minutes, amount: 0 };
        if (get().customDuration.amount !== undefined)
            return get().customDuration;
        var _millis = get().getFillDelayUiMillis() * 2 * get().getChunks();
        var resolution = lodash_1.default.find([TimeResolution.Days, TimeResolution.Hours, TimeResolution.Minutes], function (r) { return r <= _millis; }) || TimeResolution.Minutes;
        return { resolution: resolution, amount: Number((0, bignumber_js_1.default)(_millis / resolution).toFixed(2)) };
    },
    getFillDelayText: function (translations) { return (0, exports.fillDelayText)(get().getFillDelayUiMillis(), translations); },
    getFillDelayUiMillis: function () { return get().customFillDelay.amount * get().customFillDelay.resolution; },
    getDurationMillis: function () { return (get().getDurationUi().amount || 0) * get().getDurationUi().resolution; },
    getMinimumDelayMinutes: function () { var _a; return (((_a = get().lib) === null || _a === void 0 ? void 0 : _a.estimatedDelayBetweenChunksMillis()) || 0) / 1000 / 60; },
    getFillDelayWarning: function () {
        return get().lib && get().getFillDelayUiMillis() < get().getMinimumDelayMinutes() * 60 * 1000;
    },
    switchTokens: function () {
        var srcToken = get().srcToken;
        var dstToken = get().dstToken;
        var dstAmount = get().getDstAmount();
        var dstAmountUi = get().getDstAmountUi();
        get().setTokens(dstToken, srcToken);
        get().setSrcAmountUi(dstAmount.isZero() ? "" : dstAmountUi);
        set({
            srcUsd: get().dstUsd,
            dstUsd: get().srcUsd,
            srcBalance: get().dstBalance,
            dstBalance: get().srcBalance,
        });
    },
    getSrcChunkAmount: function () { var _a; return ((_a = get().lib) === null || _a === void 0 ? void 0 : _a.srcChunkAmount(get().getSrcAmount(), get().getChunks())) || (0, bignumber_js_1.default)(0); },
    getDstMinAmountOut: function () {
        return get().lib && get().srcToken && get().dstToken && get().getLimitPrice(false).limitPrice.gt(0)
            ? get().lib.dstMinAmountOut(get().srcToken, get().dstToken, get().getSrcChunkAmount(), get().getLimitPrice(false).limitPrice, !get().isLimitOrder)
            : (0, bignumber_js_1.default)(1);
    },
    setSrcAmountPercent: function (percent) {
        var srcToken = get().srcToken;
        var balance = get().srcBalance;
        var setSrcAmountUi = get().setSrcAmountUi;
        var maxAmount = get().getMaxSrcInputAmount();
        if (!srcToken) {
            return;
        }
        //max amount will be greater than zero only if the src token is native token
        var _maxAmount = maxAmount && percent === 1 && maxAmount.gt(0) ? maxAmount : undefined;
        setSrcAmountUi((0, exports.amountUi)(srcToken, _maxAmount || balance.times(percent)));
    },
    shouldWrap: function () {
        return get().lib &&
            get().srcToken &&
            get().dstToken &&
            [twap_1.TokensValidation.wrapAndOrder, twap_1.TokensValidation.wrapOnly].includes(get().lib.validateTokens(get().srcToken, get().dstToken));
    },
    shouldUnwrap: function () { return get().lib && get().srcToken && get().dstToken && get().lib.validateTokens(get().srcToken, get().dstToken) === twap_1.TokensValidation.unwrapOnly; },
    isInvalidTokens: function () { return get().lib && get().srcToken && get().dstToken && get().lib.validateTokens(get().srcToken, get().dstToken) === twap_1.TokensValidation.invalid; },
    setShowConfirmation: function (showConfirmation) { return set({ showConfirmation: showConfirmation, confirmationClickTimestamp: (0, moment_1.default)() }); },
    getDeadline: function () {
        return (0, moment_1.default)(get().confirmationClickTimestamp)
            .add((get().getDurationUi().amount || 0) * get().getDurationUi().resolution)
            .add(1, "minute")
            .valueOf();
    },
    getDeadlineUi: function () { return (0, moment_1.default)(get().getDeadline()).format("ll HH:mm"); },
    getDstAmountUi: function () { return (0, exports.amountUi)(get().dstToken, get().getDstAmount()); },
    getSrcAmountUsdUi: function () { return (0, exports.amountUi)(get().srcToken, get().getSrcAmount().times(get().srcUsd)); },
    getDstAmountUsdUi: function () { return (0, exports.amountUi)(get().dstToken, get().getDstAmount().times(get().dstUsd)); },
    getSrcBalanceUi: function () { return (0, exports.amountUi)(get().srcToken, get().srcBalance); },
    getDstBalanceUi: function () { return (0, exports.amountUi)(get().dstToken, get().dstBalance); },
    getSrcChunkAmountUi: function () { return (0, exports.amountUi)(get().srcToken, get().getSrcChunkAmount()); },
    getDstMinAmountOutUi: function () { return (get().getDstMinAmountOut().eq(1) ? "" : (0, exports.amountUi)(get().dstToken, get().getDstMinAmountOut())); },
    getSrcChunkAmountUsdUi: function () { return (0, exports.amountUi)(get().srcToken, get().getSrcChunkAmount().times(get().srcUsd)); },
    getChunksBiggerThanOne: function () { return !!get().srcToken && !!get().srcAmountUi && get().getMaxPossibleChunks() > 1; },
}); }));
var parseOrderUi = function (lib, tokensWithUsd, o) {
    var srcToken = tokensWithUsd.find(function (t) { return (0, web3_candies_1.eqIgnoreCase)(o.ask.srcToken, t.address); });
    var dstToken = tokensWithUsd.find(function (t) { return (0, web3_candies_1.eqIgnoreCase)(o.ask.dstToken, t.address); });
    var srcUsd = srcToken === null || srcToken === void 0 ? void 0 : srcToken.usd;
    var dstUsd = dstToken === null || dstToken === void 0 ? void 0 : dstToken.usd;
    if (!srcToken || !dstToken || !srcUsd || !dstUsd)
        throw new Error("parseOrderUi srcToken:".concat(srcToken, " dstToken:").concat(dstToken));
    var isMarketOrder = lib.isMarketOrder(o);
    var dstPriceFor1Src = lib.dstPriceFor1Src(srcToken, dstToken, srcUsd, dstUsd, o.ask.srcBidAmount, o.ask.dstMinAmount);
    var dstAmount = lib.dstAmount(srcToken, dstToken, o.ask.srcAmount, srcUsd, dstUsd, dstPriceFor1Src, isMarketOrder);
    var srcRemainingAmount = o.ask.srcAmount.minus(o.srcFilledAmount);
    var progress = lib.orderProgress(o) < 0.99 ? lib.orderProgress(o) * 100 : 100;
    var status = progress === 100 ? twap_1.Status.Completed : lib.status(o);
    return {
        order: o,
        ui: {
            srcToken: srcToken,
            dstToken: dstToken,
            status: status,
            progress: progress,
            isMarketOrder: isMarketOrder,
            dstPriceFor1Src: dstPriceFor1Src,
            srcUsdUi: srcUsd.toFormat(),
            dstUsdUi: dstUsd.toFormat(),
            srcAmountUi: (0, exports.amountUi)(srcToken, o.ask.srcAmount),
            srcAmountUsdUi: (0, exports.amountUi)(srcToken, o.ask.srcAmount.times(srcUsd)),
            dstAmountUi: (0, exports.amountUi)(dstToken, dstAmount),
            dstAmountUsdUi: (0, exports.amountUi)(dstToken, dstAmount.times(dstUsd)),
            dstAmountUsd: dstAmount.times(dstUsd),
            srcChunkAmountUi: (0, exports.amountUi)(srcToken, o.ask.srcBidAmount),
            srcChunkAmountUsdUi: (0, exports.amountUi)(srcToken, o.ask.srcBidAmount.times(srcUsd)),
            srcFilledAmountUi: (0, exports.amountUi)(srcToken, o.srcFilledAmount),
            srcFilledAmountUsdUi: (0, exports.amountUi)(srcToken, o.srcFilledAmount.times(srcUsd)),
            srcRemainingAmountUi: (0, exports.amountUi)(srcToken, srcRemainingAmount),
            srcRemainingAmountUsdUi: (0, exports.amountUi)(srcToken, srcRemainingAmount.times(srcUsd)),
            dstMinAmountOutUi: (0, exports.amountUi)(dstToken, o.ask.dstMinAmount),
            dstMinAmountOutUsdUi: (0, exports.amountUi)(dstToken, o.ask.dstMinAmount.times(dstUsd)),
            fillDelay: o.ask.fillDelay * 1000 + lib.estimatedDelayBetweenChunksMillis(),
            createdAtUi: (0, moment_1.default)(o.time * 1000).format("ll HH:mm"),
            deadlineUi: (0, moment_1.default)(o.ask.deadline * 1000).format("ll HH:mm"),
            prefix: isMarketOrder ? "~" : "≥",
            totalChunks: o.ask.srcAmount.div(o.ask.srcBidAmount).integerValue(bignumber_js_1.default.ROUND_CEIL).toNumber(),
        },
    };
};
exports.parseOrderUi = parseOrderUi;
var amountBN = function (token, amount) { return (0, web3_candies_1.parsebn)(amount).times((0, bignumber_js_1.default)(10).pow((token === null || token === void 0 ? void 0 : token.decimals) || 0)); };
exports.amountBN = amountBN;
var amountUi = function (token, amount) {
    if (!token)
        return "";
    var percision = (0, bignumber_js_1.default)(10).pow((token === null || token === void 0 ? void 0 : token.decimals) || 0);
    return amount.times(percision).idiv(percision).div(percision).toFormat();
};
exports.amountUi = amountUi;
var fillDelayText = function (value, translations) {
    if (!value) {
        return "0";
    }
    var time = moment_1.default.duration(value);
    var days = time.days();
    var hours = time.hours();
    var minutes = time.minutes();
    var seconds = time.seconds();
    var arr = [];
    if (days) {
        arr.push("".concat(days, " ").concat(translations.days, " "));
    }
    if (hours) {
        arr.push("".concat(hours, " ").concat(translations.hours, " "));
    }
    if (minutes) {
        arr.push("".concat(minutes, " ").concat(translations.minutes));
    }
    if (seconds) {
        arr.push("".concat(seconds, " ").concat(translations.seconds));
    }
    return arr.join(" ");
};
exports.fillDelayText = fillDelayText;
var handleFillDelayText = function (text, minutes) {
    return text.replace("{{minutes}}", minutes.toString());
};
exports.handleFillDelayText = handleFillDelayText;
exports.useOrdersStore = (0, zustand_1.create)(function (set) { return ({
    tab: 0,
    setTab: function (value) { return set({ tab: value }); },
}); });
var WizardAction;
(function (WizardAction) {
    WizardAction["CREATE_ORDER"] = "CREATE_ORDER";
    WizardAction["CANCEL_ORDER"] = "CANCEL_ORDER";
    WizardAction["WRAP"] = "WRAP";
    WizardAction["APPROVE"] = "APPROVE";
    WizardAction["UNWRAP"] = "UNWRAP";
})(WizardAction = exports.WizardAction || (exports.WizardAction = {}));
var WizardActionStatus;
(function (WizardActionStatus) {
    WizardActionStatus["PENDING"] = "PENDING";
    WizardActionStatus["SUCCESS"] = "SUCCESS";
    WizardActionStatus["ERROR"] = "ERROR";
})(WizardActionStatus = exports.WizardActionStatus || (exports.WizardActionStatus = {}));
exports.useWizardStore = (0, zustand_1.create)(function (set, get) { return ({
    action: undefined,
    status: undefined,
    error: undefined,
    open: false,
    timeout: undefined,
    setAction: function (action) {
        set({ action: action, open: !!action });
        clearTimeout(get().timeout);
    },
    setStatus: function (status, error) {
        clearTimeout(get().timeout);
        set({ status: status, error: error, open: !!status });
        if (status === WizardActionStatus.SUCCESS) {
            set({ timeout: setTimeout(function () { return set({ open: false }); }, 5000) });
        }
    },
    setOpen: function (value) { return set({ open: value }); },
}); });
var getTokenFromTokensList = function (tokensList, addressOrSymbol) {
    if (!tokensList || !addressOrSymbol)
        return;
    if (lodash_1.default.isArray(tokensList))
        return lodash_1.default.find(tokensList, function (token) { return (0, web3_candies_1.eqIgnoreCase)(addressOrSymbol, token.address) || (0, web3_candies_1.eqIgnoreCase)(addressOrSymbol, token.symbol); });
    if (lodash_1.default.isObject(tokensList))
        return tokensList[addressOrSymbol];
};
exports.getTokenFromTokensList = getTokenFromTokensList;
